import axios from "axios";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

// File API cliet
const httpFileClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  timeout: 10000,
});

// Attach token to both clients
[httpFileClient].forEach((client) => {
  client.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("authToken");
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );
});

// Handle errors
const handleError = (error) => {
  const response = error.response;

  if (response?.data?.message === "Unauthenticated.") {
    localStorage.removeItem("authToken");
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      html: '<div class="alert alert-primary" role="alert"><strong>Session </strong>timeout</div>',
      confirmButtonColor: "#c21607",
      confirmButtonText: "OK",
    }).then(() => {
      window.location.replace("/login");
    });
    return;
  }

  return {
    status: false,
    code: response?.status || 500,
    message: response?.data?.message || error.message || "Unknown error",
    data: response?.data || null,
  };
};

// Handle response
const handleResponse = (response) => ({
  status: true,
  code: response.status,
  message: response.data?.message || "Success",
  data: response.data,
});

// File API call with progress
const apiFileRequestCall = async (
  method,
  url,
  options = {},
  onUploadProgress
) => {
  try {
    const response = await httpFileClient({
      method,
      url,
      ...options,
      onUploadProgress: (progressEvent) => {
        if (onUploadProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onUploadProgress(percentCompleted);
        }
      },
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

// Export multiple functions
export default apiFileRequestCall;
